import { ActionButton } from '../concept/action-button';

export interface AttentionItem {
  id: string;
  name: string;
  initials: string;
  headline: string;
  detail: string;
  actionLabel: string;
}

/**
 * A row of the "Needs your attention" queue.
 *
 * Deliberately one line of why and one line of evidence. The deck's principle
 * slide gives the coach ten seconds for the whole screen, which is not enough
 * to read a table.
 */
export const AttentionRow: React.FC<{
  item: AttentionItem;
  onAction: () => void;
  onOpen: () => void;
  last?: boolean;
}> = ({ item, onAction, onOpen, last }) => (
  <div
    data-testid={`attention-${item.id}`}
    className={`flex items-center gap-3.5 py-3 ${last ? '' : 'border-b border-divider'}`}
  >
    <button
      type="button"
      onClick={onOpen}
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent text-[11px] font-semibold text-accent-foreground"
      aria-label={`Open ${item.name}`}
    >
      {item.initials || '—'}
    </button>
    <button type="button" onClick={onOpen} className="min-w-0 flex-1 text-left">
      <span className="flex items-baseline gap-2.5">
        <span className="truncate text-[13px] font-semibold">{item.name}</span>
        <span className="truncate text-xs text-foreground-soft">{item.headline}</span>
      </span>
      <span className="tabular mt-0.5 block truncate text-[11px] text-muted-foreground">
        {item.detail}
      </span>
    </button>
    <ActionButton onClick={onAction} testId={`action-${item.id}`}>
      {item.actionLabel}
    </ActionButton>
  </div>
);
